export default __webpack_public_path__ + "static/dell-8b67afd237a7d3f92ee228c7da7a3baa.jpg";